
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interest-form",
      function () {
        return require("private-next-pages/interest-form/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interest-form"])
      });
    }
  